import { SectionChart } from "apps/ai-metrics/components/shared/SectionChart/SectionChart";
import { SectionHeader } from "apps/ai-metrics/components/shared/SectionHeader/SectionHeader";
import { StatCard } from "apps/ai-metrics/components/shared/StatCard/StatCard";
import { useSectionStyles as useStyles } from "apps/ai-metrics/components/shared/useSectionStyles";
import {
  SECTION_NOTES,
  getMetricHelp,
  getChartHelp,
} from "apps/ai-metrics/config/metricHelpText";

const CARD_META = [
  { label: "PR CYCLE TIME", subtitle: "Created → Merged (hours)" },
  { label: "AVG COMMITS / PR", subtitle: "Commits per pull request" },
  { label: "NUMBER OF PRs", subtitle: "Total pull requests" },
  { label: "TEST FILES IN PRs", subtitle: "PRs including test files" },
];

export const PrHealthSection = (): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.section}>
      <SectionHeader title="PR & Code Health" note={SECTION_NOTES.prhealth}>
        <div className={styles.cardsRow}>
          {CARD_META.map(({ label, subtitle }) => (
            <StatCard
              key={label}
              label={label}
              subtitle={subtitle}
              value="—"
              pending={true}
              info={getMetricHelp(label)}
            />
          ))}
        </div>
        <SectionChart
          title="PR Cycle Time by Team (hours)"
          emptyMessage="PR Health data coming soon"
          info={getChartHelp("PR Cycle Time by Team (hours)")}
        />
      </SectionHeader>
    </div>
  );
};
